export const Arrow = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 0L16 8H0L8 0Z" fill="currentColor" />
  </svg>
);
